// src/components/ai/WelcomeScreen.js
import { useState } from 'react';
import { BsSend, BsStars } from 'react-icons/bs';

// مسیر تصویر webp
const LOTUS_BG_URL = '/images/lotus-bg.webp';

export default function WelcomeScreen({ onSend }) {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (query.trim()) onSend(query);
  };

  return (
    <div className="relative flex flex-col items-center justify-center h-full px-4 text-center overflow-hidden">
      {/* تصویر پس‌زمینه با پوشش کامل */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${LOTUS_BG_URL})` }}
      />
      {/* overlay تیره برای خوانایی متن (اختیاری – می‌توانید opacity را کم کنید) */}
      <div className="absolute inset-0 bg-black/30" />

      {/* محتوای روی تصویر */}
      <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-lg">
        {/* آیکون اسپارک */}
        <div className="mb-6 relative">
          <BsStars className="text-5xl text-white/80 animate-pulse" />
          <div className="absolute -top-2 -left-2 w-6 h-6 bg-white/30 rounded-full opacity-75 animate-ping" />
        </div>

        <h1
          className="text-3xl font-extrabold text-white mb-3 drop-shadow-lg"
          style={{ fontFamily: 'Doran, sans-serif' }}
        >
          دستیار هوشمند فرزانه
        </h1>
        <p className="text-sm text-white/90 max-w-md mb-8 leading-relaxed drop-shadow-md">
          همراه شما در ژرف‌کاوی آثار و اندیشه‌های استاد مصطفی ملکیان.
          <br />
          بپرسید تا با هم بیاموزیم...
        </p>

        {/* کادر ورودی شیشه‌ای بدون حاشیه */}
        <div className="w-full relative p-[2px] rounded-2xl bg-gradient-to-r from-purple-400/20 to-teal-400/20">
          <div className="backdrop-blur-xl bg-white/10 rounded-2xl p-4">
            <textarea
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSubmit();
                }
              }}
              placeholder="پرسش خود را بنویسید..."
              rows={2}
              className="w-full min-h-[56px] px-3 py-2 bg-transparent border-none outline-none text-sm resize-none text-white placeholder:text-white/50"
              style={{ fontFamily: 'Doran, sans-serif' }}
            />
            <div className="flex justify-end mt-2">
              <button
                onClick={handleSubmit}
                disabled={!query.trim()}
                className={`flex items-center gap-2 px-5 py-2 rounded-xl text-sm font-medium transition-all duration-300 ${
                  query.trim()
                    ? 'bg-gradient-to-r from-purple-600 to-teal-500 text-white shadow-md shadow-purple-200/30 hover:from-purple-700 hover:to-teal-600 active:scale-95'
                    : 'bg-gray-500/50 text-gray-300 cursor-not-allowed'
                }`}
              >
                <BsSend size={14} />
                <span> </span>
              </button>
            </div>
          </div>
        </div>

        <p className="text-xs text-white/60 mt-4">
          Enter برای ارسال &nbsp;·&nbsp; Shift+Enter برای خط جدید
        </p>
      </div>
    </div>
  );
}